import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Facility, FacilityType } from "src/app/shared/model/facility";

@Component({
    selector: "app-facility-results",
    templateUrl: "./facility-results.component.html",
    styleUrls: ["./facility-results.component.scss"]
})
export class FacilityResultsComponent {
    @Input() facilities: Facility[] = [];
    @Input() searching = false;
    @Input() searchAttempted = false;

    @Output() facilitySelected = new EventEmitter<Facility>();

    FacilityType = FacilityType;

    selectFacility(facility: Facility): void {
        this.facilitySelected.emit(facility);
    }
}
